import { defaultMemoize } from "reselect";

import { Memories } from "../../../models/state/memories/Memories";
import * as memorySelectors from "./memory";

const getMemory = (state: Memories, sectionId: string) => state.get(sectionId);

export const getMemoryForSection = getMemory;

export const getMemoriesForCourse = (state: Memories, courseId: string) =>
  state.filter(memory => memorySelectors.getCourseId(memory) === courseId);

export const noMemoriesStored = (state: Memories) => !state.size;

export const sectionHasMemory = (state: Memories, sectionId: string) =>
  !!getMemory(state, sectionId);

export const getMemoriesCount = (state: Memories) => state.size;

export const getMemories = defaultMemoize((state: Memories) => state.toList());

export const getAllMemoryLocationIds = defaultMemoize((state: Memories) =>
  getMemories(state).map(memory => memorySelectors.getLocationId(memory))
);
